import { Tag, Tooltip } from "@shared/ui";
import type { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import styles from "./styles.module.scss";

type ExecutionInfluencerStatusProps = {
  briefInfluencer?: IBriefCampaignBriefInfluencer;
};

function confirmationLabel(briefInfluencer?: IBriefCampaignBriefInfluencer) {
  if (briefInfluencer?.isConfirmed) return "Confirmed";
  if (briefInfluencer?.isConfirmationSent) return "Confirmation Sent";
  return "Confirmation Pending";
}

export function ExecutionInfluencerStatus({
  briefInfluencer,
}: ExecutionInfluencerStatusProps) {
  const confirmation = confirmationLabel(briefInfluencer);

  return (
    <div className={styles.statusColumn}>
      <div className={styles.statusContent}>
        <Tooltip title="Purchased">
          <span className={styles.statusTagWrapper}>
            <Tag color="green" className={styles.statusTag}>
              Purchased
            </Tag>
          </span>
        </Tooltip>
        <Tooltip title={confirmation}>
          <p className={styles.statusDescription}>{confirmation}</p>
        </Tooltip>
      </div>
    </div>
  );
}
